import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useProto } from '../../contexts/PrototypeContext';
import { VolunteerDiscountCard } from '../customer/VolunteerDiscountCard';
import { FieldTag } from '../shared/FieldTag';
import { Annotation } from '../shared/Annotation';
import { formatOfferAmount } from '../../utils/format';
export function CustomerPreview() {
  const {
    state,
    summary
  } = useProto();
  const [width, setWidth] = useState<'mobile' | 'desktop'>('mobile');
  const {
    amount,
    message
  } = state.config;
  const hidden = summary.available === 0;
  const sources = [{
    label: 'Discount amount',
    value: amount > 0 ? formatOfferAmount(amount) : '—',
    tag: <FieldTag kind="calculated" data-id="element-41" data-mp="2wc7on8h8z62u" />,
    note: 'From the program amount above'
  }, {
    label: 'Custom message',
    value: message.trim() ? 'Shown' : 'None — hidden',
    tag: <FieldTag kind="editable" data-id="element-42" data-mp="318ofwbjqu0k5" />,
    note: 'Your optional message'
  }, {
    label: 'Legal terms',
    value: 'Always shown',
    tag: <FieldTag kind="system" data-id="element-43" data-mp="3g2oy91ewrwp3" />,
    note: 'Legal-approved, not editable'
  }];
  return <section aria-labelledby="preview-title" className="rounded-xl border border-connect-line bg-connect-canvas p-5" data-id="element-44" data-mp="3g0c7pzv34e0f">
      <div className="flex items-center justify-between gap-4" data-id="element-45" data-mp="364940pkl47bd">
        <div className="flex items-center gap-2" data-id="element-46" data-mp="366lk0x6s87ls">
          <EyeIcon className="h-4 w-4 text-connect-blue" aria-hidden="true" data-id="element-47" data-mp="323p97snhhfse" />
          <h4 id="preview-title" className="font-medium text-connect-ink" data-id="element-48" data-mp="2nivo41j5i6i">Customer preview</h4>
          <span className="text-xs text-connect-muted" data-id="element-49" data-mp="3tu3jzg07abzu">Volunteer Info step</span>
        </div>
        <div role="radiogroup" aria-label="Preview width" className="inline-flex rounded-md border border-connect-line bg-white p-0.5 text-xs" data-id="element-50" data-mp="3p3dcnx87rz2i">
          {(['mobile', 'desktop'] as const).map(w => <button key={w} type="button" role="radio" aria-checked={width === w} onClick={() => setWidth(w)} className={`rounded px-2.5 py-1 capitalize transition-colors duration-150 ${width === w ? 'bg-connect-blue text-white' : 'text-connect-muted hover:text-connect-ink'}`} data-id="element-51" data-mp="lea3301yiyi9">
              {w}
            </button>)}
        </div>
      </div>

      {hidden && <p className="mt-3 flex items-center gap-2 text-sm text-status-outInk" data-id="element-52" data-mp="213jd719xfj8a">
          <EyeOffIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="2634dbf0u1xml" />
          Not visible to customers right now — no opportunities are available.
        </p>}

      <div className={`mx-auto mt-4 rounded-lg bg-white p-4 shadow-sm transition-[max-width] duration-200 ease-out ${width === 'mobile' ? 'max-w-[380px]' : 'max-w-full'}`} data-id="element-54" data-mp="1x4k0uvlv8k6t">
        <VolunteerDiscountCard amount={amount} message={message} size={width} data-id="element-55" data-mp="1n5uqrp07o414" />
      </div>

      <dl className="mt-4 grid grid-cols-3 gap-4" data-id="element-56" data-mp="1n7ny76inesa6">
        {sources.map(s => <div key={s.label} data-id="element-57" data-mp="3clkhq4p10qlm">
            <dt className="flex items-center gap-1.5 text-xs text-connect-muted" data-id="element-58" data-mp="3hjlxogr5o9sv">{s.label} {s.tag}</dt>
            <dd className="mt-1 text-sm font-medium text-connect-ink" data-id="element-59" data-mp="15w8ye7zjgk81">{s.value}</dd>
            <dd className="text-xs text-connect-muted" data-id="element-60" data-mp="10xfkiegcar7c">{s.note}</dd>
          </div>)}
      </dl>
      <Annotation kind="rule" title="Disclaimer is system-controlled" className="mt-4" data-id="element-61" data-mp="1fmbre86nty6d">
        The Legal-approved terms always render inside the offer card below a divider. Franchisees can't edit or hide them, and customers don't check a box to accept them.
      </Annotation>
    </section>;
}